import { createAtom, useSelector } from '@tanstack/react-store';
import { useIsEmbedded } from '@web/intacct/build-type';

export const navMenuVisibilityAtom = createAtom(false);

export function setForceSITNavVisible(forceSITNavVisible: boolean) {
  navMenuVisibilityAtom.set(forceSITNavVisible);
}

export function useSITNavVisible() {
  const visible = useSelector(navMenuVisibilityAtom, (state) => state);
  const isEmbedded = useIsEmbedded();
  return isEmbedded ? visible : true;
}
